module.exports = __webpack_public_path__ + "img/02.cf009e6e.png";